import React, { Component } from 'react';
import PropTypes from 'prop-types';
const defaultAlbumArt = 'https://albumart.customchannels.rocks/default-album-art.png';

class AlbumArt extends Component {

  constructor(props){
    super(props);

    this.state = { 
        albumArtUrl: this.props.albumArtUrl
    };

    this.handleError = this.handleError.bind(this);
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      albumArtUrl: nextProps.albumArtUrl
    });
  }

  handleError(){
      this.setState({
          albumArtUrl: defaultAlbumArt
      });
  }

  render(){
    return (
      <div className="AlbumArt">
        <img 
          className="rounded"
          onError={ this.handleError }
          alt={ this.props.album } 
          src={ this.state.albumArtUrl } />
      </div>
    );
  }
}

AlbumArt.propTypes = {
  album: PropTypes.string.isRequired,
  albumArtUrl: PropTypes.string.isRequired
};

export default AlbumArt;



// WEBPACK FOOTER //
// ./src/AlbumArt.js